import { Redirect } from "react-router-dom";
import { useAuthState } from "../../utilities/contexts/auth-state-context";
import AssessmentResults from "../../components/assessment-results/assessment-results";
import { useTranslation } from 'react-i18next';

export interface AssessmentHomePageProps {

}

const COMPONENT_CLASS = "p-assessment-home";

const AssessmentHomePage: React.FunctionComponent<AssessmentHomePageProps> = () => {
    const { state } = useAuthState();
    const { t } = useTranslation();

    if (state.user && !state.user.isAccountSetup) {
        return <Redirect to="/setup" />;
    }
    if (!state.authenticated) {
        return <Redirect to="/login" />;
    }
    if (state.user && state.user?.leadLinkId && state.user.organizationId === process.env.REACT_APP_LEAD_CAPTURE_ORG_ID) {
        return <Redirect to="/lc-assessment-results" />
    }
    if (state.user && state.user?.subscriptionLinkId) {
        return <Redirect to="/wellness-results" />
    }

    return (
        <div className={`${COMPONENT_CLASS}`}>
            <AssessmentResults secondScreenButtonText={t('buttons.btn_learnMore')} showYourWellnessProgramSectionWithoutLicense={false} />
        </div>
    );
};

export default AssessmentHomePage;